<template>
  <div>
    <customize-page label-position="left" ref="page" inline :loading="loading" :data="dataList" :columns="columns"
      :pagination="pagination" :formConfig="getFormConfig()" :filterObj="filterObj" @size-change="handleSizeChange"
      @on-selection-change="selectionChange" @current-change="handleCurrentChange">
      <div slot="footer">
        <el-button size="mini" type="primary" @click="search"> 搜索 </el-button>
        <el-button size="mini" @click="reset">重置</el-button>
        <el-button size="mini" @click="exportList"> 导出 </el-button>
        <!-- <el-button size="mini" @click="exportDetail"> 导出详情 </el-button> -->
        <el-button size="mini" type="primary" v-hp="'reccb'" @click="restApplySelection">
          清单重推
        </el-button>
        <el-button size="mini" type="primary" v-hp="'reccb'" @click="restPortSelection">
          订单重推
        </el-button>
        <el-button size="mini" type="success" v-hp="'retpl'" @click="restTplSelection">
          运单重推
        </el-button>
        <el-button size="mini" type="warning" v-hp="'reWms'" @click="restWmsSelection">
          仓库重推
        </el-button>
        <el-button size="mini" type="success" v-hp="'reWms'" @click="reMailNoSelection">
          回传运单
        </el-button>
        <!--        <el-button-->
        <!--          v-if="isShangHaiEnv"-->
        <!--          style="margin-right: 10px"-->
        <!--          type="warning"-->
        <!--          v-hp="'reccb'"-->
        <!--          @click="tagNoNeedLowDeclare"-->
        <!--        >-->
        <!--          标记为非低报单-->
        <!--        </el-button>-->
        <el-button size="mini" type="primary" v-if="isShangHaiEnv" @click="handleImportDeclare">
          导入订单
        </el-button>
        <el-button size="mini" type="primary" v-if="isShangHaiEnv" @click="handleBatchCancel">
          取消订单
        </el-button>
        <el-button size="mini" type="primary" v-if="isShangHaiEnv" @click="handleManualSync">
          同步订单
        </el-button>
      </div>
    </customize-page>

    <el-dialog width="80%" title="轨迹日志" :visible.sync="dialogTableVisible">
      <el-table :row-class-name="tableRowClassName" :data="traceLogData" height="380">
        <el-table-column property="appName" label="应用" width="120"></el-table-column>
        <el-table-column property="time" label="时间" width="100"></el-table-column>
        <el-table-column property="content" label="内容">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column property="traceLevel" label="级别" width="60"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="改快递" width="400px" :visible.sync="modifyCarrierVisible">
      <el-form :inline="true" :model="modifyCarrierForm">
        <el-form-item label="快递">
          <el-select filterable v-model="modifyCarrierForm.carrierCode">
            <el-option v-for="item in carrierAllList" :key="item.code" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyCarrierVisible = false">取消</el-button>
        <el-button type="primary" @click="modifyCarrier">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="400px" title="批量取消订单" :visible="showBatchCancelVisible" @close="showBatchCancelVisible = false">
      <el-form :inline="true" :model="batchCancelForm">
        <el-form-item label="订单号">
          <el-input type="textarea" autosize v-model="batchCancelForm.merchantOrderNoList"
            placeholder="请输入订单号,多个单号以回车换行" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showBatchCancelVisible = false">取消</el-button>
        <el-button type="primary" @click="doBatchCancel">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="420px" title="手动同步订单" :visible.sync="showManualSyncVisible" @close="closeManualSync">
      <el-form ref="manualSyncFormRef" :model="manualSyncForm" :rules="manualSyncRules" label-width="100px">
        <el-form-item label="店铺" prop="shopCode">
          <el-select v-model="manualSyncForm.shopCode" placeholder="请选择店铺" style="width: 100%" filterable>
            <el-option v-for="item in dewuShopList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号" prop="subOrderNo">
          <el-input v-model.trim="manualSyncForm.subOrderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeManualSync">取消</el-button>
        <el-button type="primary" :loading="manualSyncLoading" @click="doManualSync">
          确定
        </el-button>
      </span>
    </el-dialog>

    <el-dialog :title="reCustomsDeclare.title" width="36%" :visible.sync="reCustomsDeclare.isReApply">
      <div slot="title">
        <div style="float: left" v-text="reCustomsDeclare.title"></div>
        <div style="float: right; margin-right: 8%" v-text="reCustomsDeclare.msg"></div>
      </div>
      <el-table :data="reCustomsDeclare.currentReApplyData">
        <el-table-column align="center" property="bizId" label="订单号" min-width="250"></el-table-column>
        <el-table-column align="center" property="state" label="状态" min-width="150"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="reApplyCustoms(reCustomsDeclare.type, scope.row)" type="text" size="small">
              重试
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <logistics-track :steps="trackSteps" :status="trackStatus" :mailNo="trackMailNo" :visible="trackVisible"
      @close="handleCloseTrack"></logistics-track>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import LogisticsTrack from "@/components/LogisticsTrack";
import Page from "@/mixin/Page";

import { mapGetters, mapState } from "vuex";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import declareApi from "@/api/declare";
import dewuApi from "@/api/dewu";
import shopAuthApi from "@/api/shopAuthApi";
import authApi from "@/api/auth";
import logistics from "../../api/logistics";
import moment from "moment";

export default {
  components: {
    CustomizePage,
    LogisticsTrack,
  },
  mixins: [Page],
  created() {
    authApi.getOmsUserInfo().then((res) => {
      this.userInfo = res;
      this.fetch();
      this.fetchAllShop();
    });
  },
  data() {
    let originMerchantOrderNoColumn = [];
    let lowDeclareColumn = [];

    if (CONST_VD_IMGPREFIX.env === "SHANGHAI") {
      originMerchantOrderNoColumn.push({
        title: "原始订单号",
        width: 200,
        key: "originMerchantOrderNo",
        align: "center",
      });
      lowDeclareColumn.push({
        title: "是否低报单",
        width: 130,
        key: "isLowDeclare",
        align: "center",
        render: (h, params) => {
          let isLowDeclare = params.row.isLowDeclare;
          const tagType = isLowDeclare === "是" ? "error" : "info";
          return (
            <div>
              <el-tag type={tagType}>{isLowDeclare}</el-tag>
            </div>
          );
        },
      });
      lowDeclareColumn.push({
        title: "标记为非低报单",
        width: 140,
        key: "noNeedLowDeclare",
        align: "center",
        render: (h, params) => {
          let noNeedLowDeclare = params.row.noNeedLowDeclare;
          const tagType = noNeedLowDeclare === "是" ? "success" : "info";
          return (
            <div>
              <el-tag type={tagType}>{noNeedLowDeclare}</el-tag>
            </div>
          );
        },
      });
    }
    return {
      userInfo: {},
      traceLogData: [],
      trackSteps: [],
      trackStatus: "",
      trackMailNo: "",
      trackVisible: false,
      modifyCarrierVisible: false,
      modifyCarrierForm: {
        bizId: "",
        carrierCode: "",
      },
      batchCancelForm: {
        merchantOrderNoList: "",
      },
      manualSyncForm: {
        shopCode: "",
        subOrderNo: "",
      },
      manualSyncRules: {
        shopCode: [
          { required: true, message: "请选择店铺", trigger: "change" },
        ],
        subOrderNo: [
          { required: true, message: "请输入订单号", trigger: "blur" },
        ],
      },
      showBatchCancelVisible: false,
      showManualSyncVisible: false,
      manualSyncLoading: false,
      dialogTableVisible: false,
      loading: false,
      dataList: [],
      shopList: [],
      successInfos: [],
      failInfos: [],
      uploadData: {
        _aid: 401,
      },
      uploadName: "CPRODUCT_IMG.xlsx",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "商户单号/申报订单号",
          width: 260,
          fixed: "left",
          key: "merchantOrderNo",
          align: "center",
          render: (h, params) => {
            let bizId = params.row.bizId;
            return (
              <div>
                <div>{params.row.originMerchantOrderNo}</div>
                <a
                  style="color:blue"
                  onClick={this.showDetail.bind(this, bizId)}
                >
                  {params.row.merchantOrderNo}
                </a>
              </div>
            );
          },
        },
        {
          title: "所属平台",
          width: 100,
          key: "merchantName",
          align: "center",
        },
        {
          title: "店铺",
          width: 220,
          key: "subChannelName",
          align: "center",
          render: (h, params) => {
            return (
              <div>
                <div>{params.row.subChannelName}</div>
                <div>{params.row.subChannelCode}</div>
              </div>
            );
          },
        },
        {
          title: "出库状态",
          width: 160,
          key: "stateStr",
          align: "center",
          render: (h, params) => {
            if (params.row.stateStr === "已出库") {
              return (
                <div>
                  <div>{params.row.stateStr}</div>
                  <div>{params.row.warehouseStockoutTimeStr}</div>
                </div>
              );
            }
            return <div>{params.row.stateStr}</div>;
          },
        },
        {
          title: "仓库操作状态",
          width: 160,
          key: "wmsOperationStatus",
          align: "center",
          render: (h, params) => {
            return (
              <div>
                <div>
                  {this.wmsOperationStatusMap[params.row.wmsOperationStatus]}
                </div>
                <div>{params.row.wmsOperationTime}</div>
              </div>
            );
          },
        },
        {
          title: "是否异常",
          width: 120,
          align: "center",
          render: (h, params) => {
            const isException = !!params.row.exceptionMsg;
            return isException ? (
              <div>
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content={params.row.exceptionMsg}
                >
                  <el-tag type="danger" slot="reference">
                    异常
                  </el-tag>
                </el-popover>
              </div>
            ) : null;
          },
        },
        {
          title: "是否下发wms",
          width: 120,
          key: "isWmsSend",
          align: "center",
          render: (h, params) => {
            let isWmsSend = params.row.isWmsSend;
            const tagType = isWmsSend ? "success" : "info";
            return (
              <div>
                <el-tag type={tagType}>
                  {isWmsSend ? "已下发" : "未下发"}
                </el-tag>
              </div>
            );
          },
        },
        // ...lowDeclareColumn,
        //清单申报
        {
          title: "是否申报清单",
          width: 120,
          key: "ccbIsDeclareStr",
          align: "center",
        },
        {
          title: "清关状态",
          width: 120,
          key: "ccbState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            // if(row.ccbBizState==="800"){
            let state = row.ccbState;
            return (
              <div>
                <el-tooltip className="item" effect="light" placement="top">
                  <div slot="content">{row.ccbStateDesc}</div>
                  <el-button>{state}</el-button>
                </el-tooltip>
              </div>
            );
            //}
            //return <div>{row.ccbBizRemark}</div>;
          },
        },
        {
          title: "清单编号",
          width: 200,
          key: "ccbBizId",
          align: "center",
        },
        {
          title: "清单申报时间",
          width: 180,
          key: "ccbSendTimeStr",
          align: "center",
        },
        {
          title: "清单回执时间",
          width: 180,
          key: "ccbReturnTimeStr",
          align: "center",
        },

        //运单申报
        {
          title: "是否申报运单",
          width: 130,
          key: "tplIsDeclareStr",
          align: "center",
        },
        {
          title: "运单状态",
          width: 150,
          key: "tplState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            // if(row.ccbBizState==="800"){
            let state = row.tplState;
            return (
              <div>
                <el-tooltip className="item" effect="light" placement="top">
                  <div slot="content">{row.tplStateDesc}</div>
                  <el-button>{state}</el-button>
                </el-tooltip>
              </div>
            );
            //}
            //return <div>{row.ccbBizRemark}</div>;
          },
        },
        {
          title: "运单申报时间",
          width: 180,
          key: "tplSendTimeStr",
          align: "center",
        },
        {
          title: "运单回执时间",
          width: 180,
          key: "tplReturnTimeStr",
          align: "center",
        },
        {
          title: "承运商",
          width: 120,
          key: "carrierName",
          align: "center",
        },
        {
          title: "运单号",
          width: 200,
          key: "mailNo",
          align: "center",
        },

        //订单申报
        {
          title: "是否申报订单",
          width: 130,
          key: "orderIsDeclareStr",
          align: "center",
        },
        {
          title: "订单状态",
          width: 150,
          key: "orderState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            // if(row.ccbBizState==="800"){
            let state = row.orderState;
            return (
              <div>
                <el-tooltip className="item" effect="light" placement="top">
                  <div slot="content">{row.orderStateDesc}</div>
                  <el-button>{state}</el-button>
                </el-tooltip>
              </div>
            );
            //}
            //return <div>{row.ccbBizRemark}</div>;
          },
        },
        {
          title: "订单申报时间",
          width: 180,
          key: "orderSendTimeStr",
          align: "center",
        },
        {
          title: "订单回执时间",
          width: 180,
          key: "orderReturnTimeStr",
          align: "center",
        },
        //支付单
        // {
        //   title: "是否申报支付",
        //   width: 130,
        //   key: "payIsDeclareStr",
        //   align: "center"
        // },
        // {
        //   title: "支付单状态",
        //   width: 150,
        //   key: "payState",
        //   align: "center",
        //   render: (h, param) => {
        //     let row = param.row;
        //     // if(row.ccbBizState==="800"){
        //     let state = row.payState;
        //     return (
        //       <div>
        //         <el-tooltip className="item" effect="light" placement="top">
        //           <div slot="content">{row.payStateDesc}</div>
        //           <el-button>{state}</el-button>
        //         </el-tooltip>
        //       </div>
        //     );
        //     //}
        //     //return <div>{row.ccbBizRemark}</div>;
        //   }
        // },
        // {
        //   title: "支付单申报时间",
        //   width: 180,
        //   key: "paySendTimeStr",
        //   align: "center"
        // },
        // {
        //   title: "支付单回执时间",
        //   width: 180,
        //   key: "payReturnTimeStr",
        //   align: "center"
        // },
        // {
        //   title: "仓库",
        //   width: 200,
        //   key: "warehouseName",
        //   align: "center",
        // },
        // {
        //   title: "支付类型",
        //   width: 200,
        //   key: "payTypeStr",
        //   align: "center",
        // },
        // {
        //   title: "支付流水号",
        //   width: 250,
        //   key: "payTradeNo",
        //   align: "center",
        // },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "操作",
          width: 250,
          align: "center",
          render: (h, params) => {
            const stateStr = params.row.stateStr;
            return (
              <div>
                {["已出库", "已取消"].indexOf(params.row.stateStr) > -1 ? (
                  ""
                ) : (
                  <el-button
                    type="text"
                    onClick={this.handleCancelOrder.bind(this, params.row)}
                  >
                    取消出库
                  </el-button>
                )}
                {["已出库"].includes(params.row.stateStr) ? (
                  <el-button
                    type="text"
                    onClick={this.showTrack.bind(this, params.row)}
                  >
                    物流轨迹
                  </el-button>
                ) : (
                  ""
                )}
                <el-button
                  type="text"
                  onClick={this.showTracelogDetail.bind(this, params.row)}
                >
                  轨迹日志
                </el-button>
                {["待出库"].includes(params.row.stateStr) ? (
                  <el-button
                    type="text"
                    onClick={this.showModifyCarrier.bind(this, params.row)}
                  >
                    改快递
                  </el-button>
                ) : null}
              </div>
            );
          },
        },
      ],
      filterObj: {
        merchantOrderNo: "",
        invtNo: "",
        bizId: "",
        applyTime: [],
        state: "WAIT_STOCKOUT",
        gmtCreate: [
          new Date(
            parseFloat(
              moment()
                .subtract(3, "day")
                .startOf("day")
                .format("x"),
            ),
          ),
          new Date(
            parseFloat(
              moment()
                .endOf("day")
                .format("x"),
            ),
          ),
        ],
      },
      currentRow: [],
      sortObj: {},
      customsType: {
        ccb: "ccb",
        tpl: "tpl",
        wms: "wms",
        mail: "mail",
        low: "low",
        port: "port",
      },
      reCustomsDeclare: {
        msg: "",
        title: "重推",
        isReApply: false,
        currentReApplyData: [],
        successNum: 0,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState("cs", {
      carrierAllList: "carrierAllList",
    }),
    ...mapState("channelStore", {
      allChannelList: "allChannelList",
    }),
    ...mapGetters([
      "subChannelListForSH",
      "subChannelList",
      "subChannelNameMapping",
      "getEECommerce",
      "subChannelNameMappingForSH",
      "wmsOperationStatusMap",
      "getCustomerList",
    ]),
    isShangHaiEnv() {
      return CONST_VD_IMGPREFIX.env === "SHANGHAI";
    },
    dewuShopList() {
      return this.shopList.filter((item) => item.type === "DEWU");
    },
  },
  methods: {
    handleBatchCancel() {
      this.showBatchCancelVisible = true;
    },
    handleManualSync() {
      if (this.dewuShopList.length <= 0) {
        this.$message.warning("暂无可同步的得物店铺");
        return;
      }
      this.manualSyncForm = {
        shopCode:
          this.dewuShopList.length === 1 ? this.dewuShopList[0].value : "",
        subOrderNo: "",
      };
      this.showManualSyncVisible = true;
      this.$nextTick(() => {
        if (this.$refs.manualSyncFormRef) {
          this.$refs.manualSyncFormRef.clearValidate();
        }
      });
    },
    closeManualSync() {
      this.showManualSyncVisible = false;
      this.manualSyncLoading = false;
      this.manualSyncForm = {
        shopCode: "",
        subOrderNo: "",
      };
    },
    doManualSync() {
      if (!this.$refs.manualSyncFormRef) {
        return;
      }
      this.$refs.manualSyncFormRef.validate((valid) => {
        if (!valid || this.manualSyncLoading) {
          return;
        }
        this.manualSyncLoading = true;
        dewuApi
          .createOrderBySubOrderNo({
            request: {
              shopCode: this.manualSyncForm.shopCode,
              subOrderNo: this.manualSyncForm.subOrderNo,
            },
          })
          .then((res) => {
            if (res) {
              this.$message.success("手动同步成功");
              this.closeManualSync();
              this.fetch();
              return;
            }
            this.$message.error("手动同步失败");
          })
          .catch(() => {
            this.$message.error("手动同步失败");
          })
          .finally(() => {
            this.manualSyncLoading = false;
          });
      });
    },
    async doBatchCancel() {
      const merchantOrderNoList = this.batchCancelForm.merchantOrderNoList;
      const list = merchantOrderNoList.split("\n");
      for (let i = 0; i < list.length; i++) {
        const merchantOrderNo = list[i].trim();
        if (!merchantOrderNo) {
          continue;
        }
        try {
          const res = await declareApi.cancelOrderByMerchantOrderNo({
            merchantOrderNo,
          });
          if (!res.value) {
            this.$message.error(`取消失败, 商户单号: ${merchantOrderNo}`);
          } else {
            this.$message.success(`取消成功, 商户单号: ${merchantOrderNo}`);
          }
        } catch (e) {
          console.error(e);
        }
      }
      this.showBatchCancelVisible = false;
      this.batchCancelForm.merchantOrderNoList = "";
      this.fetch();
    },
    handleCloseTrack() {
      this.trackVisible = false;
    },
    tableRowClassName({ row, rowIndex }) {
      let traceLevel = row.traceLevel;
      if (traceLevel === "DEBUG") {
        return "debug-row";
      } else if (traceLevel === "WRAN") {
        return "warning-row";
      } else if (traceLevel === "INFO") {
        return "success-row";
      } else {
        return "error-row";
      }
    },
    handleCancelOrder(row) {
      this.$confirm(
        `此操作将取消出库单:${row.originMerchantOrderNo}, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        let bizId = row.bizId;
        this.loading = true;
        declareApi
          .cancelOrder({ request: { bizIds: [bizId] } })
          .then((res) => {
            if (res.value) {
              this.$message({
                message: "取消成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "取消失败",
                type: "error",
              });
            }
            this.loading = false;

            this.fetch();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    canCancel(row) {
      return false;
    },
    cancelStockout(row) {
      this.$confirm("此操作将取消出库单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let bizId = row.bizId;
        this.loading = true;
        this.$store
          .dispatch("cancelStockout", {
            bizId,
          })
          .then((res) => {
            if (res.isSuccess) {
              this.$message({
                message: "取消成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "取消失败",
                type: "error",
              });
            }
            this.loading = false;

            this.fetch();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    showTrack(row) {
      logistics.track({ bizId: row.bizId }).then((res) => {
        const result = JSON.parse(res.value);
        if (result.data.result !== "true") {
          this.$message.error("获取轨迹失败");
          return;
        }
        this.trackVisible = true;
        this.trackSteps = result.data.steps.reverse();
        this.trackMailNo = result.data.mailno;
        this.trackStatus = result.data.status;
      });
    },
    showTracelogDetail(row) {
      this.traceLogData = [];
      let bizId = row.bizId;
      this.loading = true;
      this.$store
        .dispatch("traceDetail", {
          bizId,
        })
        .then((res) => {
          this.loading = false;
          this.traceLogData = res.tracelogItems;
          this.dialogTableVisible = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showModifyCarrier(row) {
      this.modifyCarrierForm.bizId = row.bizId;
      this.modifyCarrierVisible = true;
    },
    modifyCarrier() {
      if (!this.modifyCarrierForm.carrierCode) {
        return this.$message.error("请选择快递");
      }
      if (!this.modifyCarrierForm.bizId) {
        return this.$message.error("请选择出库单");
      }
      declareApi
        .modifyCarrier({
          request: {
            bizId: this.modifyCarrierForm.bizId,
            carrierCode: this.modifyCarrierForm.carrierCode,
          },
        })
        .then((res) => {
          if (res.value) {
            this.$message.success("修改成功");
            this.modifyCarrierVisible = false;
            this.modifyCarrierForm = {
              bizId: "",
              carrierCode: "",
            };
            this.fetch();
          }
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    // 更新品牌列表
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      if (filterParams.applyTime != null) {
        filterParams.declarePassGmtStart = filterParams.applyTime[0];
        filterParams.declarePassGmtEnd = filterParams.applyTime[1];
        //delete filterParams.applyTime;
      } else {
        delete filterParams.declarePassGmtStart;
        delete filterParams.declarePassGmtEnd;
      }

      if (filterParams.gmtCreate != null) {
        filterParams.gmtCreateStart = moment(filterParams.gmtCreate[0]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        filterParams.gmtCreateEnd = moment(filterParams.gmtCreate[1]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        delete filterParams.gmtCreate;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }

      if (filterParams.userOrderTotalMin) {
        filterParams.userOrderTotalMin =
          Number(filterParams.userOrderTotalMin) * 100;
      }

      if (filterParams.userOrderTotalMax) {
        filterParams.userOrderTotalMax =
          Number(filterParams.userOrderTotalMax) * 100;
      }

      if (!filterParams.gmtCreateStart) {
        if (
          !filterParams.merchantOrderNo &&
          !filterParams.originMerchantOrderNo &&
          !filterParams.invtNo &&
          !filterParams.mailNo &&
          filterParams.state !== "WAIT_STOCKOUT"
        ) {
          this.$message.warning({
            message:
              "查询条件至少要有以下一个:商户订单号、原始订单号、清单编号、运单号不为空，出库状态为待出库",
            duration: 5000,
          });
          this.loading = false;
          return;
        }
      }

      const sortObj = this.sortObj;

      let searchCondition = {
        ...sortObj,
        request: {
          condition: filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };

      this.$store.dispatch("sc", {
        page: "customsDeclareList",
        param: searchCondition,
      });
      let __this = this;
      this.$store
        .dispatch("queryDeclareOrderList", searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        });
    },
    reApplyCustoms(type, data) {
      let result = null;
      let lastState = data.state;
      data.state = "请稍等";
      switch (type) {
        case this.customsType.ccb:
          result = this.restApply(data.bizId);
          break;
        case this.customsType.tpl:
          result = this.restTpl(data.bizId);
          break;
        case this.customsType.wms:
          result = this.reWms(data.bizId);
          break;
        case this.customsType.mail:
          result = this.reMailNo(data.bizId);
          break;
        case this.customsType.low:
          result = this.reTagNoNeedLowDeclare(data.bizId);
          break;
        case this.customsType.port:
          result = this.restPort(data.bizId);
          break;
        default:
          this.$message.warning("重推类型不正确，请稍后重试");
          return;
      }
      this.reApplyCustomsHandler(result, data, lastState);
    },
    showReApplyDialog(title, type, total) {
      let reApplyData = [];
      this.reCustomsDeclare.total = total;
      this.reCustomsDeclare.successNum = 0;
      this.reCustomsDeclare.type = type;
      this.reCustomsDeclare.title = title;
      this.reCustomsDeclare.currentReApplyData = reApplyData;
      this.reCustomsDeclare.isReApply = !this.reCustomsDeclare.isReApply;
      return reApplyData;
    },
    restApply(bizId) {
      //this.loading = true;
      return this.$store.dispatch("restApply", {
        bizId,
        pati: localStorage.getItem("pdd_pati"),
        pageCode: localStorage.getItem("pdd_pageCode"),
      });
    },
    restPort(bizId) {
      return this.$store.dispatch("restPort", {
        bizId,
      });
    },
    restTpl(bizId) {
      //this.loading = true;
      return this.$store.dispatch("restTpl", {
        bizId,
      });
    },
    reMailNo(bizId) {
      return this.$store.dispatch("reMailNo", {
        bizId,
      });
    },
    reWms(bizId) {
      //this.loading = true;
      return this.$store.dispatch("reWms", {
        bizId: bizId,
      });
    },
    reTagNoNeedLowDeclare(bizId) {
      return this.$store.dispatch("tagNoNeedLowDeclare", {
        bizId,
      });
    },
    restApplySelection() {
      this.$confirm("确认重推选中的订单的清单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要重推的清单");
          return;
        }

        let ccbStateList = this.showReApplyDialog(
          "重推清单",
          this.customsType.ccb,
          this.currentRow.length,
        );
        for (let index in this.currentRow) {
          let ccbState = {
            bizId: this.currentRow[index].bizId,
            state: "请稍等",
          };
          ccbStateList.push(ccbState);
          this.reApplyCustomsHandler(
            this.restApply(this.currentRow[index].bizId),
            ccbState,
          );
        }
      });
    },
    restPortSelection() {
      this.$confirm("确认重推选中的订单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要重推的订单");
          return;
        }

        let portStateList = this.showReApplyDialog(
          "重推订单",
          this.customsType.port,
          this.currentRow.length,
        );
        for (let index in this.currentRow) {
          let portState = {
            bizId: this.currentRow[index].bizId,
            state: "请稍等",
          };
          portStateList.push(portState);
          this.reApplyCustomsHandler(
            this.restPort(this.currentRow[index].bizId),
            portState,
          );
        }
      });
    },
    restTplSelection() {
      this.$confirm("确认重推选中的订单的运单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要重推的运单");
          return;
        }
        let tplStateList = this.showReApplyDialog(
          "重推运单",
          this.customsType.tpl,
          this.currentRow.length,
        );
        for (let index in this.currentRow) {
          let tplState = {
            bizId: this.currentRow[index].bizId,
            state: "请稍等",
          };
          tplStateList.push(tplState);
          this.reApplyCustomsHandler(
            this.restTpl(this.currentRow[index].bizId),
            tplState,
          );
        }
      });
    },
    restWmsSelection() {
      this.$confirm("确认重新下发仓库", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要重推仓库的申报单");
          return;
        }
        let wmsStateList = this.showReApplyDialog(
          "重推仓库",
          this.customsType.wms,
          this.currentRow.length,
        );
        for (let index in this.currentRow) {
          let wmsState = {
            bizId: this.currentRow[index].bizId,
            state: "请稍等",
          };
          wmsStateList.push(wmsState);
          this.reApplyCustomsHandler(
            this.reWms(this.currentRow[index].bizId),
            wmsState,
          );
        }
      });
    },
    reMailNoSelection() {
      this.$confirm("确认手工回传运单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要重推仓库的申报单");
          return;
        }
        let stateList = this.showReApplyDialog(
          "手工回传",
          this.customsType.mail,
          this.currentRow.length,
        );
        for (let index in this.currentRow) {
          let state = {
            bizId: this.currentRow[index].bizId,
            state: "请稍等",
          };
          stateList.push(state);
          this.reApplyCustomsHandler(
            this.reMailNo(this.currentRow[index].bizId),
            state,
          );
        }
      });
    },
    tagNoNeedLowDeclare() {
      this.$confirm("确认标记为非低报单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要重推标记的低报单");
          return;
        }
        let stateList = this.showReApplyDialog(
          "标记为非低报单",
          this.customsType.low,
          this.currentRow.length,
        );
        for (let index in this.currentRow) {
          let state = {
            bizId: this.currentRow[index].bizId,
            state: "请稍等",
          };
          stateList.push(state);
          this.reApplyCustomsHandler(
            this.reTagNoNeedLowDeclare(this.currentRow[index].bizId),
            state,
          );
        }
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    reApplyCustomsHandler(reApplyCustomsPromis, data, lastState) {
      reApplyCustomsPromis
        .then((res) => {
          if (res.isSuccess === true) {
            if (lastState !== "成功") {
              this.reCustomsDeclare.successNum++;
            }
            data.state = "成功";
          } else {
            if (lastState === "成功") {
              this.reCustomsDeclare.successNum--;
            }
            data.state = "失败";
          }
          this.reCustomsDeclare.msg = `总共${this.reCustomsDeclare.total}条，成功${this.reCustomsDeclare.successNum}条`;
        })
        .catch((error) => {
          data.state = "异常";
        });
    },
    fetchAllShop() {
      return shopAuthApi
        .listAll()
        .then((res) => {
          this.shopList = res.items
            .filter((item) => {
              if (!this.userInfo.customerId) {
                return true;
              }
              return item.customerId === this.userInfo.customerId;
            })
            .map((res) => {
              return {
                label: res.shopName,
                value: res.shopCode,
                type: res.shopType,
              };
            });
        })
        .catch(() => {
          this.$message.error("店铺列表加载失败，请刷新页面重试");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      let subChannelSearchConditionConfig = [];
      let originMerchantOrderNoColumn = [];
      if (
        CONST_VD_IMGPREFIX.env == "NC" ||
        CONST_VD_IMGPREFIX.env === "SHANGHAI"
      ) {
        subChannelSearchConditionConfig.push({
          label: "店铺",
          model: "subBizType",
          type: type.SELECT,
          props: {
            data: this.shopList,
          },
        });
      }
      if (CONST_VD_IMGPREFIX.env === "SHANGHAI") {
        originMerchantOrderNoColumn.push({
          label: "原始订单号",
          model: "originMerchantOrderNo",
          type: type.INPUT,
        });
      }

      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList,
              },
            },
            {
              label: "商户订单号",
              model: "merchantOrderNo",
              type: type.INPUT,
            },
            ...originMerchantOrderNoColumn,
            {
              label: "清单编号",
              model: "invtNo",
              type: type.INPUT,
            },
            {
              label: "清关状态",
              model: "ccbBizState",
              type: type.SELECT,
              multiple: true,
              props: {
                data: [
                  { value: "-1", label: "未回执" },
                  { value: "-2", label: "异常" },
                  { value: "1", label: "电子口岸已暂存" },
                  {
                    value: "2",
                    label: "电子口岸申报中",
                  },
                  { value: "3", label: "发送海关成功" },
                  {
                    value: "4",
                    label: "发送海关失败",
                  },
                  { value: "100", label: "海关退单" },
                  {
                    value: "120",
                    label: "海关入库",
                  },
                  { value: "300", label: "人工审核" },
                  {
                    value: "399",
                    label: "海关审结",
                  },
                  { value: "800", label: "放行" },
                  {
                    value: "899",
                    label: "结关",
                  },
                  { value: "500", label: "查验" },
                  {
                    value: "501",
                    label: "扣留移送通关",
                  },
                  { value: "502", label: "扣留移送缉私" },
                  {
                    value: "503",
                    label: "扣留移送法规",
                  },
                  { value: "599", label: "其它扣留" },
                  { value: "700", label: "退运" },
                ],
              },
            },

            {
              label: "订单渠道",
              model: "orderSource",
              type: type.SELECT,
              props: {
                data: this.allChannelList,
              },
            },
            {
              label: "承运商",
              model: "carrierCode",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  ...this.carrierAllList.map((d) => {
                    return { value: d.code, label: d.name };
                  }),
                ],
              },
            },
            {
              label: "运单号",
              model: "mailNo",
              type: type.INPUT,
            },
            {
              label: "创建时间",
              model: "gmtCreate",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
              props: {
                clearable: false,
              },
            },
            {
              label: "出库状态",
              model: "state",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "WAIT_STOCKOUT",
                    label: "待出库",
                  },
                  {
                    value: "STOCKOUTING",
                    label: "出库中",
                  },
                  {
                    value: "STOCKOUT_FINISH",
                    label: "已出库",
                  },
                  {
                    value: "STOCKOUT_CANCEL",
                    label: "已取消",
                  },
                ],
              },
            },
            ...subChannelSearchConditionConfig,
            {
              label: "电商企业",
              model: "enterpriseNid",
              type: type.SELECT,
              props: {
                data: this.getEECommerce,
              },
            },
            {
              label: "wms操作状态",
              model: "wmsOperationStatus",
              type: type.SELECT,
              props: {
                data: Object.keys(this.wmsOperationStatusMap).map((v) => {
                  return { value: v, label: this.wmsOperationStatusMap[v] };
                }),
              },
            },
            {
              label: "最低实付金额",
              model: "userOrderTotalMin",
              type: type.INPUT_NUMBER,
              unit: "元",
              props: {
                controls: false,
              },
            },
            {
              label: "最高实付金额",
              model: "userOrderTotalMax",
              type: type.INPUT_NUMBER,
              unit: "元",
              props: {
                controls: false,
              },
            },
            {
              label: "抖音退款状态",
              model: "isHolding",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "1",
                    label: "拦截中未退款",
                  },
                  {
                    value: "2",
                    label: "已退款",
                  },
                ],
              },
            },
            {
              label: "料号",
              model: "itemNo",
              type: type.INPUT
            }
          ],
        },
      ];
    },
    showDetail(id) {
      this.$router.push({
        name: "customsDeclareDetail",
        params: { id },
      });
    },
    exportList(data) {
      const filterParams = this.getFilterParams();
      if (filterParams.applyTime != null) {
        filterParams.declarePassGmtStart = filterParams.applyTime[0];
        filterParams.declarePassGmtEnd = filterParams.applyTime[1];
        delete filterParams.applyTime;
      }
      if (filterParams.gmtCreate != null) {
        filterParams.gmtCreateStart = moment(filterParams.gmtCreate[0]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        filterParams.gmtCreateEnd = moment(filterParams.gmtCreate[1]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        delete filterParams.gmtCreate;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      if (Object.keys(filterParams).length == 0) {
        this.$message.warning("筛选条件不能为空");
        return;
      }
      if (filterParams.userOrderTotalMin) {
        filterParams.userOrderTotalMin =
          Number(filterParams.userOrderTotalMin) * 100;
      }

      if (filterParams.userOrderTotalMax) {
        filterParams.userOrderTotalMax =
          Number(filterParams.userOrderTotalMax) * 100;
      }
      if (!filterParams.state) {
        if (!filterParams.customerId) {
          this.$message.warning("货主Id筛选不能为空");
          return;
        }
        if (!filterParams.gmtCreateStart) {
          this.$message.warning("创建时间不能为空");
          return;
        }
        const time =
          new Date(filterParams.gmtCreateEnd).getTime() -
          new Date(filterParams.gmtCreateStart).getTime();
        if (time > 60 * 60 * 1000 * 24 * 31) {
          this.$message.warning("创建开始时间和结束时间范围不能超过31天");
          return;
        }
      }
      this.loading = true;
      const sortObj = data ? data : this.sortObj;
      this.$store
        .dispatch("submitCustomsDeclareOrderBuildExcelTask", {
          ...sortObj,
          request: {
            condition: filterParams,
            pageIndex: 1,
            pageSize: 9999,
          },
        })
        .then((res) => {
          if (res.value) {
            this.loading = false;
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.loading = false;
            this.$message.error("提交失败");
          }
        });
    },
    exportDetail(data) {
      const filterParams = this.getFilterParams();
      if (filterParams.applyTime != null) {
        filterParams.declarePassGmtStart = filterParams.applyTime[0];
        filterParams.declarePassGmtEnd = filterParams.applyTime[1];
        delete filterParams.applyTime;
      }
      if (filterParams.gmtCreate != null) {
        filterParams.gmtCreateStart = moment(filterParams.gmtCreate[0]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        filterParams.gmtCreateEnd = moment(filterParams.gmtCreate[1]).format(
          "YYYY-MM-DD HH:mm:ss",
        );
        delete filterParams.gmtCreate;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      if (Object.keys(filterParams).length == 0) {
        this.$message.warning("筛选条件不能为空");
        return;
      }
      if (filterParams.userOrderTotalMin) {
        filterParams.userOrderTotalMin =
          Number(filterParams.userOrderTotalMin) * 100;
      }

      if (filterParams.userOrderTotalMax) {
        filterParams.userOrderTotalMax =
          Number(filterParams.userOrderTotalMax) * 100;
      }
      if (filterParams.overseaState != -1) {
        if (!filterParams.customerId) {
          this.$message.warning("货主Id筛选不能为空");
          return;
        }
        if (!filterParams.gmtCreateStart) {
          this.$message.warning("创建时间不能为空");
          return;
        }
        const time =
          new Date(filterParams.gmtCreateEnd).getTime() -
          new Date(filterParams.gmtCreateStart).getTime();
        if (time > 60 * 60 * 1000 * 24 * 31) {
          this.$message.warning("创建开始时间和结束时间范围不能超过31天");
          return;
        }
      }
      this.loading = true;
      const sortObj = data ? data : this.sortObj;
      this.$store
        .dispatch("submitCustomsDeclareOrderDetailTask", {
          ...sortObj,
          request: {
            condition: filterParams,
            pageIndex: 1,
            pageSize: 9999,
          },
        })
        .then((res) => {
          if (res.value) {
            this.loading = false;
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.$message.error("提交失败");
          }
        });
    },
    handleImportDeclare() {
      this.$router.push({ name: "declareOrderImport" });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: #fdf5c9;
}

.el-table .debug-row {
  background: #b9f9ba;
}

.el-table .success-row {
  background: #b9f9ba;
}

.el-table .error-row {
  background: #f95c54;
}

.avatar-uploader {
  display: inline-block;
}
</style>
